import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import Link from '../../../../../components/ZUILib/Link';
import RadioButton from '../../../../../components/ZUILib/RadioButton';
import Monedero from './monedero';
import UserCard from './UserCardBankCreate';
import TarjetaLiverpool from './TarjetaLiverpool';
import InputButton from '../../../../../components/ZUILib/InputButton';
import commonUtil from '../../../../../utils/commonUtil';
import AlertTransferences from './alertTransferences';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();

export default class panel1 extends Component {
  constructor(props) {
    super(props);
    this.allTransferOptions = [
      { id: 0, label: 'Monedero' },
      { id: 1, label: 'Tarjeta Liverpool' },
      { id: 2, label: 'Cuenta bancaria o tarjeta Liverpool' },
      { id: 3, label: 'Cuenta bancaria o tarjeta Liverpool Premium Card' },
      { id: 4, label: 'Combinado' },
      { id: 5, label: 'Monedero Mesa de regalos' },
    ];
    this.state = {
      transferenceMethods: [],
      availableCardsInfo: null,
      isMonedero: false,
      isBankCard: false,
      isEmployee: false,
      isContinueButtonDisable: true,
      walletLengthError: false,
      selectedTransferenceMethodsCode: '',
    };
  }

  UNSAFE_componentWillMount() {
    const transferenceMethods = [];
    if (this.props.transference && this.props.transference.transferenceOptions
      && this.props.transference.transferenceOptions.transferenceMethods) {
      this.props.transference.transferenceOptions.transferenceMethods.forEach((option) => {
        if (option.code === '1') {
          if (this.props.transference.employeeCardInfo && this.props.transference.employeeCardInfo.length > 0) {
            transferenceMethods.push({ name: option.name, code: option.code });
          }
        } else {
          transferenceMethods.push({ name: option.name, code: option.code });
        }
      });
      this.setState({
        transferenceMethods,
        availableCardsInfo: this.props.transference.transferenceOptions.availableCardsInfo,
        selectedTransferenceMethodsCode: transferenceMethods.length === 1 ? transferenceMethods[0].code : '',
      });
      if (transferenceMethods.length === 1) {
        this.loadComponentByCode(transferenceMethods[0].code);
      }
    }
  }

  handleRadioSelected = (data, e) => {
    this.setState({ selectedTransferenceMethodsCode: e.target.value });
    this.loadComponentByCode(e.target.value);
  }

  loadComponentByCode = (code) => {
    if (code === '0') {
      this.setState({ isMonedero: true, isBankCard: false, isEmployee: false, isContinueButtonDisable: true });
    } else if (code === '1') {
      this.setState({ isMonedero: false, isBankCard: false, isEmployee: true, isContinueButtonDisable: true });
    } else if (code === '2' || code === '3') {
      this.setState({ isMonedero: false, isBankCard: true, isEmployee: false, isContinueButtonDisable: true });
    } else if (code === '6') {  // type : refund
      this.setState({ isContinueButtonDisable: false });
    }
  }
  walletLengthError = (isWalletLengthErro) => {
    this.setState({ walletLengthError: isWalletLengthErro });
    if (channel === constChannels.WAP) {
      commonUtil.goToTop();
    }
  }
  disableContinueButton = (isDisable) => {
    this.setState({ isContinueButtonDisable: isDisable });
  }
  onNextStepClick = () => {
    let submitTransferenceObj = null;
    let walletLengthError = false;
    if (this.state.isMonedero) {
      if ((this.monedero.walletNumber_mltpc && this.monedero.walletNumber_mltpc.getValue().length > 0 && this.monedero.walletNumber_mltpc && this.monedero.walletNumber_mltpc.getValue().length < 16) ||
        (this.monedero.walletNumber_mmdr && this.monedero.walletNumber_mmdr.getValue().length > 0 && this.monedero.walletNumber_mmdr && this.monedero.walletNumber_mmdr.getValue().length < 13)) {
        this.walletLengthError(true);
        walletLengthError = true;
      } else if (this.monedero.walletAmount_mdw && this.monedero.walletAmount_mdw.getValue().length === '') {
        this.walletLengthError(true);
        walletLengthError = true;
      } else {
        this.walletLengthError(false);
        walletLengthError = false;
        submitTransferenceObj = this.monedero.getFormData();
        this.props.submitTransferenceData(submitTransferenceObj);
      }
    } else if (this.state.isBankCard) {
      if ((this.userCard.accountNumber && this.userCard.accountNumber.getValue().length > 0 && this.userCard.accountNumber && this.userCard.accountNumber.getValue().length < 16)) {
        this.walletLengthError(true);
        walletLengthError = true;
      } else {
        this.walletLengthError(false);
        walletLengthError = false;
        submitTransferenceObj = this.userCard.getFormData();
        this.props.submitTransferenceData(submitTransferenceObj);
      }
    } else if (this.state.isEmployee) {
      submitTransferenceObj = this.tarjeta.getFormData();
      this.props.submitTransferenceData(submitTransferenceObj);
    }
    if (channel !== constChannels.WAP && !walletLengthError) { this.props.nextPage(2); }
  }
  rediectToPage = () => {
    this.props.setGiftListTransferenceStatementTab(true);
    browserHistory.push(commonUtil.routeTo(applicationRoutes.giftList, { eventID: this.props.eventId }));
  }
  render() {
    const monederoComponent = (<div> {this.state.isMonedero ? <Monedero ref={monedero => (this.monedero = monedero)} user={this.props.user} transferenceData={this.props.transference} disableContinueButton={this.disableContinueButton} lables={this.props.lables} /> : null}</div>);
    const cardBankComponent = (<div>{this.state.isBankCard ? <UserCard ref={userCard => (this.userCard = userCard)} transferenceData={this.props.transference} disableContinueButton={this.disableContinueButton} lables={this.props.lables} /> : null}</div>);
    const employeeComponent = (<div>{this.state.isEmployee ? <TarjetaLiverpool ref={tarjeta => (this.tarjeta = tarjeta)} transferenceData={this.props.transference} disableContinueButton={this.disableContinueButton} lables={this.props.lables} /> : null}</div>);

    const nextStep = {
      name: 'Siguiente',
      type: 'button',
      value: 'Siguiente',
      autoFocus: false,
      style: 'btnPrimary size-Large',
      onClickHandler: this.onNextStepClick,
      id: 'nextStep',
      iconClass: 'iconRight icon-flecha_lightsvg_derecha',
      disabled: this.state.isContinueButtonDisable ? 'disabled' : '',
    };
    const cancelButton = {
      name: 'Cancelar',
      type: 'button',
      value: 'Cancelar',
      autoFocus: false,
      style: 'btnSecondary size-Large',
      onClickHandler: this.rediectToPage,
      cssStyle: {
        borderRadius: '4px',
        backgroundColor: '#666666',
      },
    };
    const nextStepLink = {
      id: 'nextStepLink',
      text: 'Siguiente paso',
      children: 'Siguiente paso',
      href: '',
      cssStyle: {
        borderRadius: '4px !important',
        backgroundColor: 'red !important',
      },
      cssClass: this.state.isContinueButtonDisable ? 'btnPrimary size-Full hiddenStyle' : 'btnPrimary size-Full',
      onClickHandler: this.onNextStepClick,
    };

    const errorAncher = {
      cssClass: 'icon-tache2',
      onClickHandler: () => { this.setState({ walletLengthError: null }); },
    };
    const alerContainerWeb = {
      border: '1px solid #ADA8A8',
      borderRadius: '20px',
    };

    const fullContainer = {
      width: channel === constChannels.WEB ? '93%' : null,
      margin: channel === constChannels.WEB ? '4%' : null,
    };
    return (
      <div style={fullContainer}>
        {channel === constChannels.WAP ?
          <div className="col-xs-12 innerOptions" style={{ marginBottom: '10%' }}>

            <p className="text-red text-right">* Campos obligatorios</p>
            {this.state.walletLengthError ?
              <div className="alertError">
                <i className="icon-tache2" />
                <p>{commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.ewalletInvalid.message')}</p>
                <Link linkJSON={errorAncher} />
              </div>
              : null}
            {
              this.props.type === 'partial' ?
                <h3 style={{ fontFamily: 'Roboto, sans-serif' }}>Forma de déposito</h3>
              : null
             }
            <p style={{ fontWeight: '400', fontSize: '16px', color: '#3B3B3E' }}>
              Selecciona forma de depósito
            </p>
            {
                    /* eslint-disable */
                    <div>
                      {this.state.transferenceMethods.map((option, index) => (
                        option.code === '1' ? 
                          employeeComponent
                        : <RadioButton
                        key={index}
                        checked={this.state.selectedTransferenceMethodsCode === option.code}
                        displayName={option.name}
                        id={'radio_transferenceMethods_' + option.code}
                        value={option.code}
                        name="transferenceMethods" title={option.name}
                        radioCssClass={'radio radioDF'}
                        onChangeFunction={this.handleRadioSelected}
                        innerContent={option.code === '0' ? 
                          <i 
                          className="iClass icon-ayuda display-inline-block tooltip-container text-pink" 
                          style={{fontWeight: 800}}>
                          <span 
                          className={`tooltip-box tooltipBox344 tooltipIcon344`}
                          >
                            <p style={{fontSize: '16px', fontWeight: 500, padding: '0 2%'}}>
                                Transferencia a monedero
                            </p>
                            <p style={{padding: '0 2%'}}> 
                              {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.monedero.clousre.tooltip')}
                            </p>
                         </span>
                        </i> : null}
                      >
                        {option.code === '0' ? monederoComponent :
                            option.code === '2' || option.code === '3' ? cardBankComponent : null}
                      </RadioButton>
                      ))}
                    </div>
              /* eslint-enable */}

            <div className="col-xs-12 innerOptions">
              <div className="row">
                <Link linkJSON={nextStepLink}>Siguiente<i className="iconRight icon-flecha_lightsvg_derecha" aria-hidden="true" data-original-title title /></Link>
              </div>
            </div>
          </div>
          : <div className="panel">
            <div id="alert_container" style={alerContainerWeb}>
              <div className="panel-heading row" style={{ paddingTop: 0 }}>
                {
              this.props.type === 'partial' ?
                <AlertTransferences />
              : null
             }
              </div>
              <div className="panel-heading row">
                {
              this.props.type === 'partial' ?
                <div style={{ paddingLeft: '20px' }}>
                  <h3 style={{ fontFamily: 'Roboto, sans-serif' }}>Forma de déposito</h3>
                  {
                    this.props.transference && this.props.transference.isEmployee && this.props.transference.isEmployee !== 'true'
                    ? <p>Puedes realizar retiros parciales a monederos propios antes del cierre del evento.</p>
                    : null
                  }
                </div>
              : null
             }
              </div>
              <div className="panel-heading row">
                <div className="col-xs-8">
                  {this.state.walletLengthError ?
                    <div className="alertError">
                      <i className="icon-tache2" />
                      <p><p>{commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.ewalletInvalid.message')}</p></p>
                      <Link linkJSON={errorAncher} />
                    </div>
                  : null}
                </div>
                <div className="col-xs-4 errorMessage" style={{ paddingRight: '20px' }}><span className="text-red">* Campos obligatorios</span></div>
              </div>
              <div className="panel-collapse collapse in" id="step1" aria-expanded="true" style={{}}>
                <div className="panel-body row">
                  <div className="col-xs-12 depositForm" style={{ paddingLeft: '20px' }}>
                    <span className="subtitleModule" style={{ fontSize: '16px' }}>Selecciona forma de depósito</span>
                    {
                    /* eslint-disable */
                    <div style={{ paddingLeft: '20px'}}>
                      {this.state.transferenceMethods.map((option, index) => (
                        option.code === '1' ? 
                          employeeComponent
                        : <RadioButton
                        style= {{ fontSize: '16px' }}
                        key={index}
                        checked={this.state.selectedTransferenceMethodsCode === option.code}
                        displayName={option.name}
                        id={'radio_transferenceMethods_' + option.code}
                        value={option.code}
                        name="transferenceMethods" title={option.name}
                        radioCssClass={'radio radioDF'}
                        onChangeFunction={this.handleRadioSelected}
                        innerContent={option.code === '0' ? 
                          <i 
                          className="iClass icon-ayuda display-inline-block tooltip-container text-pink"
                          style={{fontWeight: 800}}>
                          <span 
                          className={`tooltip-box tooltipBox344 tooltipIcon344`}
                          >
                            <p style={{fontSize: '16px', fontWeight: 500, padding: '0 2%'}}>
                                Transferencia a monedero
                            </p>
                            <p style={{padding: '0 2%'}}> 
                              {commonUtil.getLabel(this.props.lables['Estado de Cuenta Page'], 'eventClosure.monedero.clousre.tooltip')}
                            </p>
                         </span>
                        </i> : null}
                      >
                        {option.code === '0' ? monederoComponent :
                            option.code === '2' || option.code === '3' ? cardBankComponent : null}
                      </RadioButton>
                      ))}
                    </div>
              /* eslint-enable */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row block-buttons">
              <div className="col-xs-6">
                <InputButton buttonAttr={cancelButton} />
              </div>
              <div className="col-xs-6 text-right" >
                <InputButton buttonAttr={nextStep} />
              </div>
            </div>
          </div>
        }
      </div>);
  }
}
